import React from 'react';
import { Button } from './ui/button';
import { Alert, AlertDescription } from './ui/alert';
import { useSearchParams } from 'react-router-dom';
import { Fingerprint } from 'lucide-react';

const Login = () => {
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');
  const redirect = searchParams.get('redirect');

  const handleLogin = () => {
    window.location.href = redirect
      ? `/auth/login?redirect=${encodeURIComponent(redirect)}`
      : '/auth/login';
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-surface via-surface-1 to-surface-2">
      <div className="w-full max-w-sm rounded-xl border border-white/10 bg-surface-1/90 backdrop-blur-md p-8 shadow-2xl">
        <div className="flex flex-col items-center mb-8">
          <svg width="40" height="40" viewBox="0 0 20 20" fill="#E21351" className="mb-4">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.538 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.783.57-1.838-.197-1.538-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.381-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" />
          </svg>
          <h1 className="text-2xl font-display font-bold text-ink">
            Bit<span className="text-primary-500">Starz</span>
          </h1>
          <p className="text-sm text-ink-dim mt-1">VIP Tools</p>
        </div>

        {error === 'unauthorized_domain' && (
          <Alert variant="error" className="mb-4">
            <AlertDescription>Access restricted to @bitstarz.com accounts.</AlertDescription>
          </Alert>
        )}
        {error && error !== 'unauthorized_domain' && (
          <Alert variant="error" className="mb-4">
            <AlertDescription>Authentication failed. Please try again.</AlertDescription>
          </Alert>
        )}

        <Button
          onClick={handleLogin}
          className="w-full h-12 text-base mb-4 gap-2"
        >
          <Fingerprint className="h-5 w-5" />
          Sign in with Google
        </Button>

        <p className="text-center text-xs text-ink-dim">
          Sign in with your @bitstarz.com Google account
        </p>
      </div>
    </div>
  );
};

export default Login;
